import { baseCrumbClasses } from './Breadcrumbs';

interface ButtonCrumbProps {
  buttonText: string
}

export const ButtonCrumb = (props: ButtonCrumbProps) => {
  const {
    buttonText
  } = props;

  return (
    <button className={`${baseCrumbClasses} text-sm short:text-xs md:text-base p-2 short:py-1 short:px-4 lg:px-6`}>{buttonText}</button>
  )
}